import React from 'react'

export const IconAlertTriangle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 13 12" fill="none" {...props}>
    <g clipPath="url(#clip0_2129_12884)">
      <path
        d="M5.81237 1.92961L1.57737 8.99961C1.49005 9.15083 1.44385 9.32226 1.44336 9.49687C1.44287 9.67148 1.48811 9.84318 1.57458 9.99488C1.66105 10.1466 1.78573 10.273 1.93622 10.3615C2.08671 10.4501 2.25777 10.4977 2.43237 10.4996H10.9024C11.077 10.4977 11.248 10.4501 11.3985 10.3615C11.549 10.273 11.6737 10.1466 11.7602 9.99488C11.8466 9.84318 11.8919 9.67148 11.8914 9.49687C11.8909 9.32226 11.8447 9.15083 11.7574 8.99961L7.52237 1.92961C7.43323 1.78267 7.30773 1.66117 7.15797 1.57686C7.0082 1.49254 6.83924 1.44824 6.66737 1.44824C6.4955 1.44824 6.32653 1.49254 6.17677 1.57686C6.02701 1.66117 5.9015 1.78267 5.81237 1.92961V1.92961Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66699 4.5V6.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66699 8.5H6.67199"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2129_12884">
        <rect width="12" height="12" fill="white" transform="translate(0.666992)" />
      </clipPath>
    </defs>
  </svg>
)
